declare namespace $ {

	type $shm_listener__shm_hitalama_map_pane_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_pane['keydown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_pane_2 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_pane['keyup_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_pane_3 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_pane['blur_handler'] >, ReturnType< $shm_hitalama_map_pane['window'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_pane_4 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_pane['visibilitychange_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $mol_vector_range__shm_hitalama_map_pane_5 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_range<number> >
	>
	type $mol_vector_range__shm_hitalama_map_pane_6 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_range<number> >
	>
	type $mol_vector_2d__shm_hitalama_map_pane_7 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	type $shm_hitalama_map_camera_url__state_key_shm_hitalama_map_pane_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['camera_state_key'] >
		,
		ReturnType< $shm_hitalama_map_camera_url['state_key'] >
	>
	type $shm_hitalama_map_camera_url__zoom_default_shm_hitalama_map_pane_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['camera_zoom_default'] >
		,
		ReturnType< $shm_hitalama_map_camera_url['zoom_default'] >
	>
	type $shm_hitalama_map_camera_url__shift_default_shm_hitalama_map_pane_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['camera_shift_default'] >
		,
		ReturnType< $shm_hitalama_map_camera_url['shift_default'] >
	>
	type $mol_vector_2d__shm_hitalama_map_pane_11 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	type $shm_hitalama_map_touch__zoom_shm_hitalama_map_pane_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['zoom'] >
		,
		ReturnType< $shm_hitalama_map_touch['zoom'] >
	>
	type $shm_hitalama_map_touch__pan_shm_hitalama_map_pane_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['shift'] >
		,
		ReturnType< $shm_hitalama_map_touch['pan'] >
	>
	type $shm_hitalama_map_touch__allow_pan_shm_hitalama_map_pane_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['allow_pan'] >
		,
		ReturnType< $shm_hitalama_map_touch['allow_pan'] >
	>
	type $shm_hitalama_map_touch__allow_draw_shm_hitalama_map_pane_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_map_touch['allow_draw'] >
	>
	type $shm_hitalama_map_touch__allow_zoom_shm_hitalama_map_pane_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['allow_zoom'] >
		,
		ReturnType< $shm_hitalama_map_touch['allow_zoom'] >
	>
	type $shm_hitalama_map_pane_tool__Map_page_shm_hitalama_map_pane_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['Map_page'] >
	>
	type $shm_hitalama_map_pane_tool__mode_shm_hitalama_map_pane_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['mode'] >
	>
	type $shm_hitalama_map_pane_tool__client_pos_to_pane_pos_shm_hitalama_map_pane_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['client_pos_to_pane_pos'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['client_pos_to_pane_pos'] >
	>
	type $shm_hitalama_map_pane_tool__to_real_pos_shm_hitalama_map_pane_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['to_real_pos'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['to_real_pos'] >
	>
	type $shm_hitalama_map_pane_tool__zoom_shm_hitalama_map_pane_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['zoom'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['zoom'] >
	>
	type $shm_hitalama_map_pane_tool__pan_shm_hitalama_map_pane_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['shift'] >
		,
		ReturnType< $shm_hitalama_map_pane_tool['pan'] >
	>
	type $shm_hitalama_map_back__event_pointerdown_shm_hitalama_map_pane_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['back_event_pointerdown'] >
		,
		ReturnType< $shm_hitalama_map_back['event_pointerdown'] >
	>
	type $shm_hitalama_map_back__event_contextmenu_shm_hitalama_map_pane_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['back_event_contextmenu'] >
		,
		ReturnType< $shm_hitalama_map_back['event_contextmenu'] >
	>
	type $mol_drop__Sub_shm_hitalama_map_pane_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['Back'] >
		,
		ReturnType< $mol_drop['Sub'] >
	>
	type $mol_drop__drop_shm_hitalama_map_pane_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_pane['event_drop'] >
		,
		ReturnType< $mol_drop['drop'] >
	>
	type $mol_view__minimal_height_shm_hitalama_map_pane_27 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_view['minimal_height'] >
	>
	type $mol_view__minimal_width_shm_hitalama_map_pane_28 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_view['minimal_width'] >
	>
	type $mol_view__sub_shm_hitalama_map_pane_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_pane_30 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_pane['transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_map_pane_31 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_map_pane['select_rect_left'] >,
			'top': ReturnType< $shm_hitalama_map_pane['select_rect_top'] >,
			'width': ReturnType< $shm_hitalama_map_pane['select_rect_width'] >,
			'height': ReturnType< $shm_hitalama_map_pane['select_rect_height'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_vector_2d__shm_hitalama_map_pane_32 = $mol_type_enforce<
		[ ReturnType< $shm_hitalama_map_pane['dimensions_viewport_x'] >, ReturnType< $shm_hitalama_map_pane['dimensions_viewport_y'] > ]
		,
		ConstructorParameters< typeof $mol_vector_2d<$mol_vector_range<number>> >
	>
	export class $shm_hitalama_map_pane extends $mol_view {
		selecting( next?: boolean ): boolean
		keydown_handler( ): any
		keydown_listener( ): $shm_listener
		keyup_handler( ): any
		keyup_listener( ): $shm_listener
		blur_handler( ): any
		window( ): any
		blur_listener( ): $shm_listener
		visibilitychange_handler( ): any
		visibilitychange_listener( ): $shm_listener
		ctrl_pressed( next?: boolean ): boolean
		drag_mode_enabled( next?: boolean ): boolean
		shift_pressed( next?: boolean ): boolean
		viewport_shifting( next?: boolean ): boolean
		pointer_client_pos( next?: readonly(number)[] ): readonly(number)[]
		dimensions_viewport_x( ): $mol_vector_range<number>
		dimensions_viewport_y( ): $mol_vector_range<number>
		view_rect( ): any
		camera_state_key( ): string
		camera_zoom_default( ): number
		camera_shift_default( ): $mol_vector_2d<number>
		Camera_url( ): $shm_hitalama_map_camera_url
		zoom( next?: number ): number
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		cursor_position( ): ReturnType< ReturnType< $shm_hitalama_map_pane['Touch'] >['pointer_center'] >
		allow_pan( ): boolean
		allow_zoom( ): boolean
		action_type( ): ReturnType< ReturnType< $shm_hitalama_map_pane['Touch'] >['action_type'] >
		action_point( ): ReturnType< ReturnType< $shm_hitalama_map_pane['Touch'] >['action_point'] >
		Touch( ): $shm_hitalama_map_touch
		tool_mode( ): string
		Tool( ): $shm_hitalama_map_pane_tool
		back_event_pointerdown( next?: any ): any
		back_event_contextmenu( next?: any ): any
		Back( ): $shm_hitalama_map_back
		event_drop( next?: any ): any
		Drop( ): $mol_drop
		outside( ): readonly(any)[]
		Line_vert( ): $mol_view
		Line_hor( ): $mol_view
		body( ): readonly(any)[]
		transform( ): string
		Content( ): $mol_view
		select_rect_left( next?: string ): string
		select_rect_top( next?: string ): string
		select_rect_width( next?: string ): string
		select_rect_height( next?: string ): string
		Select_rect( ): $mol_view
		select_rect( ): readonly(any)[]
		pointer_move( next?: any ): any
		pointer_down( next?: any ): any
		pointer_up( next?: any ): any
		pane_contextmenu( next?: any ): any
		wheel( next?: any ): any
		cursor_style( ): string
		Map_page( ): $shm_hitalama_map_page
		attr( ): ({ 
			'selecting': ReturnType< $shm_hitalama_map_pane['selecting'] >,
		})  & ReturnType< $mol_view['attr'] >
		minimal_height( ): number
		minimal_width( ): number
		pointer_pos( ): readonly(any)[]
		real_pointer_pos( ): readonly(number)[]
		to_real_pos( id: any): any
		auto( ): readonly(any)[]
		dimensions_viewport( ): $mol_vector_2d<$mol_vector_range<number>>
		box_in_viewport( next?: ReturnType< $shm_hitalama_map_pane['dimensions_viewport'] > ): ReturnType< $shm_hitalama_map_pane['dimensions_viewport'] >
		center_to_point( id: any): any
		touch_event_disabled( ): boolean
		view_rect_ensured( ): ReturnType< $shm_hitalama_map_pane['view_rect'] >
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
		select_rect_start_x( next?: number ): number
		select_rect_start_y( next?: number ): number
		select_rect_end_x( next?: number ): number
		select_rect_end_y( next?: number ): number
		select_rect_size( ): readonly(any)[]
		select_rect_pos( ): readonly(any)[]
		select_start( next?: any ): any
		select_resize( next?: any ): any
		client_pos_to_pane_pos( id: any): any
		prevent_shift_x( next?: boolean ): boolean
		prevent_shift_y( next?: boolean ): boolean
		event( ): ({ 
			pointermove( next?: ReturnType< $shm_hitalama_map_pane['pointer_move'] > ): ReturnType< $shm_hitalama_map_pane['pointer_move'] >,
			pointerdown( next?: ReturnType< $shm_hitalama_map_pane['pointer_down'] > ): ReturnType< $shm_hitalama_map_pane['pointer_down'] >,
			pointerup( next?: ReturnType< $shm_hitalama_map_pane['pointer_up'] > ): ReturnType< $shm_hitalama_map_pane['pointer_up'] >,
			contextmenu( next?: ReturnType< $shm_hitalama_map_pane['pane_contextmenu'] > ): ReturnType< $shm_hitalama_map_pane['pane_contextmenu'] >,
			wheel( next?: ReturnType< $shm_hitalama_map_pane['wheel'] > ): ReturnType< $shm_hitalama_map_pane['wheel'] >,
		})  & ReturnType< $mol_view['event'] >
		style( ): ({ 
			'cursor': ReturnType< $shm_hitalama_map_pane['cursor_style'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
}

//# sourceMappingURL=pane.view.tree.d.ts.map